import * as Axios from 'axios';
import BaseService from './BaseService';
import store from '@/store';
import { Sso, SsoSettings } from '@/domain/common';

export default class SsoService extends BaseService {
    public async getAllSso(): Promise<Sso[]> {
        console.log("getAllSso"); 

        const apiConfig: Axios.AxiosRequestConfig = {
            method: 'get',
            url: `${store.state.apiBase}/pc/users/sso/settings`,
            headers: { Authorization: `Bearer ${store.state.$auth.token}` }
        }

        const res: Axios.AxiosResponse = await this.makeAxiosCall(apiConfig)
        console.log("getAllSso action over" , res.data); 

        return res.data as Sso[];

    }
    public async updateSsoSettings(domain: string, settings: SsoSettings, customerId?: string): Promise<void> {
        const apiConfig: Axios.AxiosRequestConfig = {
            method: 'put',
            url: `${store.state.apiBase}/pc/users/sso/settings`,
            headers: {
                Authorization: `Bearer ${store.state.$auth.token}`,
                'Content-Type': 'application/json'
            },
            data: { domain, settings, customerId }
        };

        await this.makeAxiosCall(apiConfig);
    }

}
